import { copApi } from 'api'

export interface Department {
  id: string
  name: string
}
export const fetchDepartments = () => copApi.get<Department[]>('/job-family-names')
